module.exports = __webpack_public_path__ + "img/appltCourse-img25.ef715b03.png";